import React from 'react';
import moment from 'moment';
// components
import HtmlPart from '../../parts/HtmlPart';
import CardTitlePart from '../../parts/CardTitlePart';
import ImagePart from '../../parts/ImagePart';

function isValidDelivery(date) {
  const isValidDate = moment(date, 'DD/MM/YYYY hh:mm:ss').isValid();
  const isNotDefault = moment(date, 'DD/MM/YYYY hh:mm:ss').isAfter(moment('17/01/1970', 'DD/MM/YYYY'));
  return isValidDate && isNotDefault;
}

function renderDeliveryDate(deliveryDate) {
  return isValidDelivery(deliveryDate) ? (
    <div className="u-padding-top-small u-text-center">
      Delivery date: {moment(deliveryDate, 'DD/MM/YYYY hh:mm:ss').format('Do MMMM')}
    </div>
  ) : null;
}

function renderRebookingPart(rebookingUrl) {
  return (
    rebookingUrl ? (
      <div className="u-padding-bottom u-text-center delivery-booked-card__button-link-container">
        <div>
          <a className="delivery-booked-card__button-link" href={rebookingUrl} target="_blank">
            Rebook
          </a>
        </div>
        <div className="delivery-booked-card__button-link__information-text">
        *Should you need to change your delivery date, please click on the Rebook button. 
        Please note that if you do need to change it, we ask for 72 hours notice otherwise an additional delivery fee will apply.
        </div>
      </div>
    ) : null
  );
}

function DeliveryBookedCard({
  orderRef, orderNo, deliveryDate, rebookingUrl, // payload vallues
  title, bodyText, headerImageUrl, headerImageAltText // umbraco values
}) {
  return (

    <div className="delivery-booked-card">
      <CardTitlePart title={title || 'Your delivery has been booked'} />
      {
        headerImageUrl ?
          <ImagePart url={headerImageUrl} alt={headerImageAltText || 'Delivery booked'} />
          : null
      }
      <div className="u-padding-x-small u-padding-top u-padding-bottom u-text-center">
        {
          <HtmlPart htmlString={bodyText} /> || null
        }
        {renderDeliveryDate(deliveryDate)}
      </div>
      {
        orderRef ? (
          <div className="u-padding-bottom-small u-text-center c-event-feed__card__extra-info">
            <strong>Order Number:</strong> {`${orderRef}/${orderNo}`}
          </div>
        ) : null
      }
      {renderRebookingPart(rebookingUrl)}
    </div>
  );
}

export default DeliveryBookedCard;



// WEBPACK FOOTER //
// ./src/cards/templates/DeliveryBookedCard.js